import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { House, CodeSlash, Grid, Pencil, Eye, Stars } from 'react-bootstrap-icons';
import { Nav, Navbar, Col } from 'react-bootstrap';
import {
  WidgetsContext,
  AppContext,
  isDemo,
  AccountContext,
  PlansContext
} from '../../../../GlobalContex';
import styles from './NavigationBar.module.css';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import usePurchases from '../../../../hooks/usePurchases';
import useNotifications from '../../../../hooks/useNotifications';

const NavigationBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery({ max: 991 });

  const [forceActiveKey, setForceActiveKey] = useState('');
  const { activeWidget } = useContext(WidgetsContext);
  const { isEmbeded } = useContext(AppContext);
  const { account } = useContext(AccountContext);
  const { isPremium } = account;
  const { plan, showPlan } = useContext(PlansContext);
  const { buy } = usePurchases();
  const notification = useNotifications();

  const goToRegister = () => {
    window.location.href = 'https://a.electricblaze.com/#/register';
  };

  const handleMenuClick = item => {
    if (item.function && typeof item.function === 'function') {
      return item.function();
    }

    if (!window.location.hash.includes(item.path)) navigate(item.path);

    if (isDemo && item.path === '/embed') {
      goToRegister();
    }

    if (item.path === '/home' || item.path === 'demo' || item.path === '/plans') {
      navigate(item.path);
    } else if (activeWidget.id) {
      !isDemo
        ? navigate(`/widgets/${activeWidget.id}${item.path}`)
        : navigate(`/demo/${activeWidget.publicId}${item.path}`);
    } else {
      return;
    }
    setForceActiveKey(item.name);
  };

  const menuOptions = [
    {
      name: 'Data',
      icon: Pencil,
      path: `/builder`
    },
    {
      name: 'Layout',
      icon: Grid,
      path: `/styles`
    }
  ];

  if (isMobile) {
    menuOptions.push({
      name: 'Preview',
      icon: Eye,
      path: `/preview`
    });
  }

  if (!isDemo) {
    if (!isEmbeded()) {
      menuOptions.push({
        name: 'Embed',
        icon: CodeSlash,
        path: `/embed`
      });

      !isPremium &&
        menuOptions.push({
          name: 'Upgrade',
          icon: Stars,
          path: `/plans`
        });
    }

    menuOptions.unshift({
      name: 'Home',
      icon: House,
      path: `/home`
    });
  }

  useEffect(() => {
    menuOptions.forEach(item => {
      if (window.location.hash.includes(item.path)) {
        setForceActiveKey(item.name);
      }
    });
  }, [location]);

  return (
    <Navbar variant="light" className={styles.NavigationBar}>
      <Nav
        className={styles.RowWrapper + ' w-100 align-center justify-content-center'}
        defaultActiveKey={'Home'}
      >
        {menuOptions.map((item, idx) => {
          const activeProp = forceActiveKey ? { active: item.name === forceActiveKey } : {};
          const Icon = item.icon;
          return (
            <Nav.Item as={Col} key={idx} className={'p-0 text-center'}>
              <Nav.Link
                className={'d-flex justify-content-center align-center h-100'}
                eventKey={item.name}
                onClick={() => handleMenuClick(item)}
                disabled={idx && !activeWidget.id}
                {...activeProp}
              >
                <div className={styles.menu_item}>
                  {Icon && <Icon className={styles.menu_item_icon} />}
                  {<div className={styles.menu_item_name}>{t(item.name)}</div>}
                </div>
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>
    </Navbar>
  );
};

export default NavigationBar;
